import React from "react";
import { Input } from "antd";

const CodeInput = props => {
    const {
        delimiter = "",
        segmentLength = 4,
        totalSegments = 4,
        allowedCharacters = /\D/g,
        outputWithDelimiter = false,
        onChange,
        onValidation,
        placeholder,
        value
    } = props;

    const maxRawLength = segmentLength * totalSegments;
    const delimiterRegex = new RegExp(`\\${delimiter}`, "g");

    const formatDisplayValue = (input) => {
        const cleaned = input.replace(allowedCharacters, "").slice(0, maxRawLength);
        const parts = cleaned.match(new RegExp(`.{1,${segmentLength}}`, "g")) || [];
        return parts.join(delimiter);
    };

    const handleChange = (e) => {
        const input = e.target.value.replace(delimiterRegex, "").replace(allowedCharacters, "");
        const trimmedInput = input.slice(0, maxRawLength);
        const finalValue = outputWithDelimiter ? formatDisplayValue(trimmedInput) : trimmedInput;
        onChange?.(finalValue);
        onValidation?.(trimmedInput.length === maxRawLength);
    };

    return (
        <Input
            value={formatDisplayValue(value ?? "")}
            onChange={handleChange}
            maxLength={maxRawLength + (totalSegments - 1) * delimiter.length}
            placeholder={
                placeholder ??
                Array(totalSegments)
                    .fill('')
                    .map(() => Array(segmentLength).fill('X').join(''))
                    .join(delimiter)
            }
        />
    );
};

export default CodeInput;